import { render, staticRenderFns } from "./CustomerHeatmap.vue?vue&type=template&id=45e0f271&"
import script from "./CustomerHeatmap.vue?vue&type=script&lang=js&"
export * from "./CustomerHeatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports